module.exports = __webpack_public_path__ + "bg-card-1.jpg";